export const LocalStorageKeys = {
  ONBOARDING_DONE_USER_IDS: 'actee_onboarding_done_user_ids',
};

export type LocalStorageKeys = (typeof LocalStorageKeys)[keyof typeof LocalStorageKeys];
